import { useMutation } from '@apollo/client';
import type { ApiOptions } from '../helpers';
import { GenerateReportDocument } from './generate.generated';

export const useGenerateReport = (options: ApiOptions<typeof GenerateReportDocument> = {}) =>
  useMutation(GenerateReportDocument, {
    ...options,
  });
